export const LABEL_ID_ALPHABET = '23456789ABCDEFGHJKMNPRTUVWXYZ';
export const LABEL_ID_LENGTH = 10;

const ID_SHAPE = new RegExp(`^[${LABEL_ID_ALPHABET}]{${LABEL_ID_LENGTH}}$`);
const ASCII_ALPHANUMERIC = /^[A-Za-z0-9]*$/;

export function checkSymbol(body: string): string {
  let weightedSum = 0;
  for (let position = 0; position < body.length; position += 1) {
    weightedSum += (position + 1) * LABEL_ID_ALPHABET.indexOf(body.charAt(position));
  }
  return LABEL_ID_ALPHABET.charAt(weightedSum % LABEL_ID_ALPHABET.length);
}

/** Two bytes per symbol: a device without a CSPRNG feeds it a hash of its own entropy. */
export const LABEL_ID_RANDOM_BYTES = 2 * (LABEL_ID_LENGTH - 1);

export function labelIdFromBytes(bytes: Uint8Array): string {
  if (bytes.length < LABEL_ID_RANDOM_BYTES) {
    throw new RangeError(`a label ID needs ${LABEL_ID_RANDOM_BYTES} random bytes`);
  }
  let body = '';
  for (let position = 0; position < LABEL_ID_LENGTH - 1; position += 1) {
    const value = ((bytes[2 * position] ?? 0) << 8) | (bytes[2 * position + 1] ?? 0);
    body += LABEL_ID_ALPHABET.charAt(value % LABEL_ID_ALPHABET.length);
  }
  return `${body}${checkSymbol(body)}`;
}

export function normalizeLabelId(raw: string): string | null {
  const compact = raw.trim().replace(/[ -]/g, '');
  // toUpperCase maps some non-ASCII characters (the ff ligature) onto alphabet symbols.
  if (!ASCII_ALPHANUMERIC.test(compact)) {
    return null;
  }
  const id = compact.toUpperCase();
  return ID_SHAPE.test(id) && id.endsWith(checkSymbol(id.slice(0, LABEL_ID_LENGTH - 1))) ? id : null;
}
